export default {
  NONE: 'none',
  REVIEW: 'review',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  REVOKED: 'revoked',
};
